import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-5 py-12">
      <div className="w-full max-w-md card-surface p-8">
        <h1 className="font-display text-3xl font-semibold text-center text-brand-ink">Set New Password</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="reset-password" type="password" required minLength={6} placeholder="New password" className="input-field" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="reset-submit" className="btn-primary w-full">Update Password</button>
        </form>
        <p className="mt-4 text-center text-sm"><Link to="/login" className="text-brand-sage hover:underline">Back to login</Link></p>
      </div>
    </div>
  );
}
